webpackJsonp([269829036549620],{

/***/ 302:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _services = __webpack_require__(302);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _animateMin = __webpack_require__(303);
	
	var _animateMin2 = _interopRequireDefault(_animateMin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Services = function Services() {
	    return _react2.default.createElement(
	        'div',
	        { id: 'services-page' },
	        _react2.default.createElement(
	            'section',
	            { className: 'pageHeader', id: 'services-header' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container py-5' },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Services'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'container small-container text-center bounceInDown animated', id: 'service-types' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row', id: 'service-list' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 text-orange text-center mb-4' },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Services & Solutions For You'
	                    )
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: '#ios-android-dev', className: 'card col-6 col-sm-4 col-md-3 services-icon-outer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'services-icon-inner' },
	                        _react2.default.createElement('img', { src: '../../images/services/android-ios.png', className: 'img-fluid orange-icon' }),
	                        _react2.default.createElement('img', { src: '../../images/services/android-ios-white.png', className: 'img-fluid white-icon' }),
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'iOS / Android',
	                            _react2.default.createElement('br', null),
	                            'Development'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: '#desktop-app-section', className: 'card col-6 col-sm-4 col-md-3 services-icon-outer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'services-icon-inner' },
	                        _react2.default.createElement('img', { src: '../../images/services/windows-icon.png', className: 'img-fluid orange-icon' }),
	                        _react2.default.createElement('img', { src: '../../images/services/windows-icon-white.png', className: 'img-fluid white-icon' }),
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Desktop App',
	                            _react2.default.createElement('br', null),
	                            'Development'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: '#web-section', className: 'card col-6 col-sm-4 col-md-3 services-icon-outer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'services-icon-inner' },
	                        _react2.default.createElement('img', { src: '../../images/services/computer-web.png', className: 'img-fluid orange-icon' }),
	                        _react2.default.createElement('img', { src: '../../images/services/computer-web-white.png', className: 'img-fluid white-icon' }),
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Web Development'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: '#technical-section', className: 'card col-6 col-sm-4 col-md-3 services-icon-outer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'services-icon-inner' },
	                        _react2.default.createElement('img', { src: '../../images/services/consultant.png', className: 'img-fluid orange-icon' }),
	                        _react2.default.createElement('img', { src: '../../images/services/consultant-white.png', className: 'img-fluid white-icon' }),
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Technical Consulting'
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'container', id: 'ios-android-section' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 col-md-6' },
	                    _react2.default.createElement(
	                        'h2',
	                        { id: 'ios-android-dev', className: 'text-orange' },
	                        'iOS / Android Development'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'A portfolio of products released on the App Store & Google Play Store. We aim for all mobile software applications to be cross platform with little variation between the platforms.'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'container', id: 'desktop-app-section' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement('div', { className: 'col-12 col-md-6' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 col-md-6 text-right' },
	                    _react2.default.createElement(
	                        'h2',
	                        { id: 'desktop-app-dev', className: 'text-orange ' },
	                        'Desktop App Development'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'With experience developing large and small bespoke software packages, the KentWeb team is can offer a trustworthy and reputable service for developing your bespoke application.'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'container', id: 'web-section' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 col-md-6' },
	                    _react2.default.createElement(
	                        'h2',
	                        { id: 'web-dev', className: 'text-orange' },
	                        'Website Development'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We Design & develop custom web applications, fitting to your specific business requirements.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Our portfolio includes large scale E-commerce websites & creative marketing websites to complex custom web applications.'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'container', id: 'technical-section' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement('div', { className: 'col-12 col-md-6' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 col-md-6 text-right' },
	                    _react2.default.createElement(
	                        'h2',
	                        { id: 'technical-dev', className: 'text-orange ' },
	                        'Technical Consulting'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'KentWeb offers expert advice for small businesses looking to automate their workflow and move into the cloud.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Adopt new solutions meeting GDPR requirements.'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Services;
	module.exports = exports['default'];

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-js-04400b52193cf144c4dd.js